import { WidgetPanel } from "@/components/dashboard-grid/WidgetPanel";
import { weekLabel } from "@shared/weeks";
import type { OriginationPayload } from "@shared/dashboardOrigination";
import { StackedColumns } from "./StackedColumns";
import { TOUCH_BG } from "./opsColors";

const SERIES = [
  { key: "email", label: "Email" },
  { key: "meeting", label: "Meeting" },
  { key: "call", label: "Call · note" },
] as const;

export function ProspectTouches({ o }: { o: OriginationPayload }) {
  return (
    <WidgetPanel
      title="Prospect touches"
      meta="per week"
      action={
        <span className="flex gap-2.5 text-[11px] text-muted-foreground">
          {SERIES.map((s) => (
            <span key={s.key} className="inline-flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${TOUCH_BG[s.key]}`} />{s.label}</span>
          ))}
        </span>
      }
      bodyClassName="overflow-hidden"
    >
      <StackedColumns
        labels={o.weeks.map(weekLabel)}
        series={SERIES.map((s) => ({ key: s.key, label: s.label, className: TOUCH_BG[s.key], values: o.touchesWeekly[s.key] }))}
      />
    </WidgetPanel>
  );
}
